import { render, staticRenderFns } from "./BroilerDashboard.vue?vue&type=template&id=123f3deb&"
import script from "./BroilerDashboard.vue?vue&type=script&lang=js&"
export * from "./BroilerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BroilerDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports